export default __webpack_public_path__ + "static/opaque-white-cards-0b2eae9dcdadfdadab11c6d092889f69.png";